import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import Navbar from "./components/common/Navbar";
import Footer from "./components/common/Footer";
import HomePage from "./pages/HomePage";
import CheckInPage from "./pages/CheckInPage";
import NotFoundPage from "./pages/NotFoundPage";
import CheckInResultPage from "./pages/CheckInResultPage";
import CostCalculatorPage from "./pages/CostCalculatorPage";
import HealthAwarenessPage from "./pages/HealthAwarenessPage";
import QuitBenefitsPage from "./pages/QuitBenefitsPage";
import SmokingStoryPage from "./pages/SmokingStoryPage";

import "./App.css";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return null;
};

const PasswordGate = ({ onSuccess }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (password === process.env.REACT_APP_ACCESS_PASSWORD) {
      setError("");
      onSuccess();
    } else {
      setError("Incorrect password");
    }
  };

  return (
    <div className="password-screen">
      <form className="password-box" onSubmit={handleSubmit}>
        <h2>QuitPact Access</h2>
        <p>Please enter the password to continue.</p>

        <input
          type="password"
          placeholder="Enter password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button type="submit">Enter</button>

        {error && <p className="password-error">{error}</p>}
      </form>
    </div>
  );
};

const App = () => {
  const [isAllowed, setIsAllowed] = useState(false);

  if (!isAllowed) {
    return <PasswordGate onSuccess={() => setIsAllowed(true)} />;
  }

  return (
    <div className="app">
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/check-in" element={<CheckInPage />} />
        <Route path="/relapse" element={<CheckInPage />} />
        <Route path="/cost-calculator" element={<CostCalculatorPage />} />
        <Route path="/check-in/result" element={<CheckInResultPage />} />
        <Route path="/health-awareness" element={<HealthAwarenessPage />} />
        <Route path="/quit-benefits" element={<QuitBenefitsPage />} />
        <Route path="/smoking-story" element={<SmokingStoryPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <Footer />
    </div>
  );
};

export default App;
